import React from 'react';

const translations = {
  ar: {
    title: "من نحن",
    desc1: "رفاد التدوير هي الكيان الوطني الذي نجح في تحويل تحديات النفايات الصناعية إلى أصول استراتيجية مربحة والتي انطلقت من قلب المنطقة الشرقية الصناعية بهوية جديدة وإرث عملياتي صلب يمتد لأكثر من أربعة عشر عاماً", 
    desc2: "لقد تجاوزنا مرحلة التنفيذ التقليدي لنقود مرحلة الإدارة الاستراتيجية وعبقرية الابتكار الهندسي. نمتلك القدرة الكاملة على تفكيك البنية التحتية للاتصالات، ومعالجة النفايات الإلكترونية والأجهزة الطبية وفرزها، وتحويل المواد المهملة إلى مواد أولية تضخ القيمة مباشرة في شريان الاقتصاد الوطني",
    mission: "رسالتنا",
    missionText:"أن نقود قطاع التدوير بوضع القواعد والحلول التشغيلية التي تتوائم مع البيئة المحلية والمدن والمناطق الصناعية السعودية، عبر تقديم خدمات تفكيك باحترافية هندسية تخدم قطاعات الاتصالات، والطب، والصناعة.",
    vision: "رؤيتنا",
    visionText: "أن نكون الشريك الأكثر موثوقية في المملكة لتحويل المخلفات الإلكترونية، والتقنية، والنفايات الصناعية إلى قيمة اقتصادية مستدامة.",
    stats: [
      { value: "+50", label: "عميل" },
      { value: "+10K", label: "طن تم تدويرها" },
      { value: "+13", label: "شريك" },
      { value: "77%", label: "كفاءة استرداد" }
    ]
  },
  en: {
    title: "About Us",
    desc1: "Rifad Recycling is the national entity that has succeeded in transforming the challenges of industrial waste into profitable strategic assets, and it started from the heart of the Industrial Eastern Province with a new identity and a solid operational legacy spanning more than 14 years.",
    desc2: "We have moved beyond the traditional execution phase to lead the stage of strategic management and engineering innovation genius. We possess the full capacity to dismantle telecommunications infrastructure, process and sort electronic (E-Waste) and medical appliances, and transform discarded materials into raw materials that pump value directly into the national economy.",
    mission: "Our Mission",
    missionText: "To lead the recycling sector by establishing operational rules and solutions tailored to the local environment and Saudi industrial cities and zones, providing expert dismantling and engineering services for the telecommunications, medical, and industrial sectors.",
    vision: "Our Vision",
    visionText: "To be the Kingdom's most trusted partner in transforming electronic, technical, and industrial waste into sustainable economic value.",
    stats: [
      { value: "+500", label: "Clients" },
      { value: "+10K", label: "Tons Recycled" },
      { value: "+50", label: "Partners" },
      { value: "99%", label: "Recovery Rate" }
    ]
  }
};

const About = ({ currentLang }) => {
  const t = translations[currentLang];
  const isRTL = currentLang === 'ar';

  return (
    <section id="about" className="about-section">
      <div className="about-overlay"></div>
      <div className="about-content">
        <h2 className="section-title">{t.title}</h2>
        <div className="about-container">
          <div className="about-text">
            <p>{t.desc1}</p>
            <p>{t.desc2}</p>
            <div className="about-cards" dir={isRTL ? "rtl" : "ltr"}>
              <div className="about-card">
                <i className="fas fa-bullseye"></i>
                <h3>{t.mission}</h3>
                <p>{t.missionText}</p>
              </div>
              <div className="about-card">
                <i className="fas fa-eye"></i>
                <h3>{t.vision}</h3>
                <p>{t.visionText}</p>
              </div>
            </div>
          </div>
          <div className="about-stats">
            {t.stats.map((stat, index) => (
              <div className="stat-card" key={index}>
                <span className="stat-value">{stat.value}</span>
                <span className="stat-label">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <style>{`
        .about-section {
          position: relative;
          padding: 5rem 2rem;
        }
        
        .about-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
        }
        
        .about-content {
          position: relative;
          z-index: 2;
          max-width: 1400px;
          margin: 0 auto;
        }
        
        .about-container {
          display: grid;
          grid-template-columns: 1fr 0.8fr;
          gap: 4rem;
          margin-top: 3rem;
          align-items: start;
        }
        
        .about-text p {
          margin-bottom: 1.2rem;
          line-height: 1.8;
          color: #1a2a3a;
          font-size: 1rem;
        }
        
        .about-cards {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 2rem;
          margin-top: 2.5rem;
        }
        
        .about-cards[dir="rtl"] {
          direction: rtl;
        }
        
        .about-cards[dir="ltr"] {
          direction: ltr;
        }
        
        .about-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border-radius: 24px;
          padding: 2rem;
          border: 1px solid rgba(83, 176, 150, 0.3);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        
        .about-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(83, 176, 150, 0.15);
          border-color: #53b096;
        }
        
        .about-card i {
          font-size: 2.2rem;
          color: #53b096;
          margin-bottom: 1.2rem;
        }
        
        .about-card h3 {
          font-size: 1.4rem;
          margin-bottom: 1rem;
          color: #1a2a3a;
        }
        
        .about-card p {
          font-size: 0.95rem;
          margin-bottom: 0;
          color: #5a6a7a;
          line-height: 1.6;
          flex-grow: 1;
        }
        
        .about-stats {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1.8rem;
          align-content: start;
        }
        
        .stat-card {
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          border-radius: 28px;
          padding: 2rem 1.5rem;
          text-align: center;
          border: 1px solid rgba(83, 176, 150, 0.3);
          transition: all 0.3s ease;
        }
        
        .stat-card:hover {
          transform: translateY(-5px);
          background: rgba(255, 255, 255, 0.95);
          border-color: #53b096;
        }
        
        .stat-value {
          display: block;
          font-size: 2.8rem;
          font-weight: 800;
          color: #53b096;
          margin-bottom: 0.5rem;
        }
        
        .stat-label {
          font-size: 0.95rem;
          color: #5a6a7a;
        }
        
        .about-section .section-title {
          color: #1a2a3a;
          text-align: center;
        }
        
        .about-section .section-title:after {
          content: '';
          display: block;
          width: 80px;
          height: 3px;
          background: linear-gradient(90deg, #53b096, #71b887, #53b096);
          margin: 1rem auto 0;
          border-radius: 2px;
        }
        
        @media (max-width: 1200px) {
          .about-container {
            gap: 3rem;
          }
          
          .about-stats {
            gap: 1.5rem;
          }
          
          .stat-value {
            font-size: 2.5rem;
          }
        }
        
        @media (max-width: 992px) {
          .about-container {
            grid-template-columns: 1fr;
            gap: 2.5rem;
          }
          
          .about-stats {
            max-width: 600px;
            margin: 0 auto;
            width: 100%;
          }
          
          .about-section {
            padding: 4rem 1.5rem;
          }
          
          .about-cards {
            max-width: 800px;
            margin: 2rem auto 0;
          }
        }
        
        @media (max-width: 768px) {
          .about-section {
            padding: 3rem 1rem;
          }
          
          .about-container {
            gap: 1.8rem;
            margin-top: 2rem;
          }
          
          .about-text p {
            font-size: 0.95rem;
            line-height: 1.7;
            margin-bottom: 1rem;
          }
          
          .about-cards {
            grid-template-columns: 1fr;
            gap: 1.2rem;
            margin-top: 1.5rem;
          }
          
          .about-card {
            padding: 1.5rem;
          }
          
          .about-card i {
            font-size: 1.8rem;
          }
          
          .about-card h3 {
            font-size: 1.2rem;
          }
          
          .about-card p {
            font-size: 0.85rem;
          }
          
          .about-stats {
            gap: 1rem;
          }
          
          .stat-card {
            padding: 1.2rem 0.8rem;
          }
          
          .stat-value {
            font-size: 1.8rem;
          }
          
          .stat-label {
            font-size: 0.8rem;
          }
        }
        
        @media (max-width: 480px) {
          .about-section {
            padding: 2rem 0.8rem;
          }
          
          .about-container {
            gap: 1.5rem;
            margin-top: 1.5rem;
          }
          
          .about-text p {
            font-size: 0.9rem;
            line-height: 1.6;
          }
          
          .about-cards {
            gap: 1rem;
          }
          
          .about-card {
            padding: 1.2rem;
          }
          
          .about-card i {
            font-size: 1.5rem;
          }
          
          .about-card h3 {
            font-size: 1.1rem;
          }
          
          .about-card p {
            font-size: 0.8rem;
          }
          
          .about-stats {
            grid-template-columns: repeat(2, 1fr);
            gap: 0.8rem;
          }
          
          .stat-card {
            padding: 1rem 0.5rem;
          }
          
          .stat-value {
            font-size: 1.5rem;
          }
          
          .stat-label {
            font-size: 0.75rem;
          }
        }
        
        @media (max-width: 360px) {
          .about-stats {
            grid-template-columns: 1fr;
            gap: 0.7rem;
          }
          
          .stat-card {
            display: flex;
            align-items: center;
            justify-content: space-between;
            text-align: left;
            padding: 0.8rem 1rem;
          }
          
          .stat-value {
            font-size: 1.3rem;
            margin-bottom: 0;
          }
          
          .stat-label {
            font-size: 0.8rem;
          }
        }
        
        @media (max-width: 768px) {
          .about-section {
            background-attachment: scroll !important;
          }
        }
        
        @supports (background-attachment: fixed) {
          .about-section {
            background-attachment: fixed;
          }
        }
      `}</style>
    </section>
  );
};

export default About;